export enum ActionTypes {
  GetProducts = 'getProducts',
  GetProductsRequest = 'getProducts.request',
  GetProductsSuccess = 'getProducts.success',
  GetProductsFailure = 'getProducts.failure',
}
